import React, { useState } from 'react';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import './promo.css';
import config from '../../../../config/environment';
import axios from 'axios';
import PageMode from '../../elements/PageMode/pageMode';

const MODES = [ 'BIG_RELEASE' ];

export default function Promo() {
    const [state, setState] = useState({
        mode: 'BIG_RELEASE_15_12_20',

        // Big Release 15 12 2020
        bigRelease15cashbackToken: ''
    });

    const modeOnChangeHandler = (event) => setState({...state, mode: event.target.value });

    // Big Release 15 12 2020
    const renderBigRelease15_12_2020 = () => {
        if (state.mode !== 'BIG_RELEASE_15_12_20') { return; }

        return(
            <div className="promo__bigRelease15_wrapper">
                <input type="text" value={ state.bigRelease15cashbackToken }  onChange={ bigRelease15cashbackTokenChangeHandler } maxLength="16" placeholder="cashback token"/>
                <button className="promo__bigRelease15_button" onClick={ bigReleaseGiveButtonHandler }>Give 1.99$</button>
            </div>
        );
    };

    const bigRelease15cashbackTokenChangeHandler = (event) => setState({ ...state, bigRelease15cashbackToken: event.target.value });

    const bigReleaseGiveButtonHandler = async () => {
        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }

        if (!state.bigRelease15cashbackToken || state.bigRelease15cashbackToken.length < 8) {
            alert('Invalid cashback token');
            return;
        }

        const body = {
            token2fa,
            cashbackToken: state.bigRelease15cashbackToken
        };

        await axios.post(config.cashbackUrl + '/add-big-release', body)
        .then(response => alert(response.data.message))
        .catch(error => alert(error.response.data.errorMsg));
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
                { renderBigRelease15_12_2020() }
            </div>
        </>
    );
};
